
import { NgModule }           from '@angular/core';
import { CommonModule , DatePipe}       from '@angular/common';
import { FormsModule, ReactiveFormsModule }        from '@angular/forms';
import { QuestionarioDinamicoComponent } from '../components/questionario-dinamico.component';
import { QuestionarioDinamicoService } from '../services/questionario-dinamico.service'
import { FileUploadModule } from './file-upload.module';
import { ConfirmacaoDialogModule } from '../util/confirmacao.dialog.module';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';


/** AngularMaterial **/
import {  MatSelectModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatInputModule, MatRadioModule, MatProgressBarModule, MatSnackBarModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { HttpService } from 'ems-oauth2-client';

/**
Lista de Componentes do MaterialDesign (importar somento o q for usar)
MaterialModule, MdAutocompleteModule, MdCheckboxModule, MdInputModule, MdRadioModule, MdSelectModule, MdSliderModule, MdSlideToggleModule, MdMenuModule, MdSidenavModule, MdToolbarModule, MdListModule, MdGridListModule, MdCardModule, MdTabsModule, MdButtonModule, MdButtonToggleModule, MdChipsModule, MdIconModule, MdProgressSpinnerModule, MdDialogModule, MdTooltipModule, MdSnackBarModule
**/

@NgModule({
    declarations: [
      QuestionarioDinamicoComponent
    ],
    exports: [
      QuestionarioDinamicoComponent
    ],
    imports: [
      FormsModule, CommonModule, ReactiveFormsModule, FileUploadModule, ConfirmacaoDialogModule,
      MatSelectModule, MatButtonModule,  MatIconModule, MatInputModule,  MatSnackBarModule, MatRadioModule, MatProgressBarModule, MatCheckboxModule, MatSelectModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatDatepickerModule, MatNativeDateModule
    ],
    entryComponents: [ ConfirmacaoDialog ],
    providers: [QuestionarioDinamicoService, DatePipe, HttpService]
})
export class QuestionarioDinamicoModule {
}
